import billingModule from '../../billing.module';

class BillingPaymentHistoryService {
    constructor(
        $q,
        billingConfigurationApiService,
        billingInvoicesApiService,
        tokenProvider
    ) {
        this.$q = $q;
        this.billingConfigurationApiService = billingConfigurationApiService;
        this.billingInvoicesApiService = billingInvoicesApiService;
        this.tokenProvider = tokenProvider;
    }

    getColumns() {
        if (this.columns) {
            return this.$q.resolve(this.columns);
        }

        var deferred = this.$q.defer();
        this.billingConfigurationApiService
            .getInvoicesConfiguration()
            .then(configurations => {
                this.columns = configurations.fields.map(column => {
                    switch (column.type) {
                        case 'date':
                            column.template = `{{item.${
                                column.name
                            } | datetime}}`;
                            break;
                        case 'status':
                            column.template = `<div uib-popover-html="item.status.tooltip" tooltip-append-to-body="true" popover-trigger="'mouseenter'" popover-placement="auto top" class="lblStatus" ng-style="{ 'color': options.colorConstants[item.status.color] || item.status.color, 'border-color': options.colorConstants[item.status.color] || item.status.color }">{{item.status.value}}</div>`;
                            break;
                        default:
                            column.template = `{{item.${column.name}}}`;
                            break;
                    }
                    return column;
                });

                this.columns.unshift({
                    name: 'status',
                    label: ' ',
                    template: `<billing-icon-payment fill="item.status.color" />`
                });
                this.columns.push({
                    name: 'Download',
                    label: ' ',
                    template:
                        "<billing-action ng-repeat='action in item.actions' action-name='{{action.action}}' action-href='{{action.href}}' custom-class='[\"icon-download\"]'></billing-action>"
                });
                deferred.resolve(this.columns);
            }, deferred.reject);
        return deferred.promise;
    }

    getPaymentHistories(offset, limit) {
        return this.billingInvoicesApiService.getInvoices({ limit, offset });
    }
}

export default billingModule.service(
    'billingPaymentHistoryService',
    BillingPaymentHistoryService
);



// WEBPACK FOOTER //
// ./modules/billing/services/payment/billingPaymentHistory.service.js